<script setup lang="ts">
defineProps({
  title: { type: String, default: '' },
  /** Adds outer page padding and flex constraints (standalone route pages). */
  standalone: { type: Boolean, default: false },
});
</script>

<template>
  <div :class="standalone ? 'botto-page' : 'botto-page-embedded'">
    <div class="botto-panel">
      <div v-if="title || $slots.actions || $slots.header" class="botto-panel__header">
        <h2 v-if="title" class="botto-panel__title">{{ title }}</h2>
        <slot name="header" />
        <div v-if="$slots.actions" class="botto-panel__actions">
          <slot name="actions" />
        </div>
      </div>

      <div class="botto-panel__content">
        <slot />
      </div>
    </div>
  </div>
</template>
